import React, { FC, memo } from 'react';
import { useMutation } from 'react-query';
import {
  DeleteTwoTone,
  ExclamationCircleOutlined,
} from '@ant-design/icons/lib';
import { Button, message, Modal } from 'antd';
import { red } from '@ant-design/colors';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { DeleteAdminProps } from 'models/adminUser';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';

export const DeleteAdminBySuperAdminButton: FC<DeleteAdminProps> = memo(
  ({ admin, onDeleted, ...buttonProps }) => {
    const [mutate, { isLoading }] = useMutation(
      BusinessPartnersAPI.deleteAdminBySuperAdmin
    );
    const intlMessage = useFormatMessage();

    const confirm = () =>
      Modal.confirm({
        title: intlMessage(
          { id: 'entity.delete.confirmation' },
          {
            name: admin.login,
          }
        ),
        icon: <ExclamationCircleOutlined />,
        okText: intlMessage({ id: 'yes' }),
        cancelText: intlMessage({ id: 'cancel' }),
        okType: 'danger',
        onOk: () =>
          mutate(
            { adminId: admin.userId },
            {
              onSuccess: () => {
                message.success(
                  intlMessage(
                    { id: 'entity.delete.success' },
                    {
                      name: admin.login,
                    }
                  )
                );
                onDeleted && onDeleted();
              },
            }
          ),
      });

    return (
      <Button
        loading={isLoading}
        onClick={() => confirm()}
        icon={<DeleteTwoTone twoToneColor={red.primary} />}
        {...buttonProps}
      >
        <FormattedMessage id="delete" tagName="span" />
      </Button>
    );
  }
);
